import { createClient } from '@supabase/supabase-js';

function readWindowConfig() {
  try {
    if (typeof window === 'undefined') return null;
    return window.__SUPABASE_CONFIG__ || null;
  } catch {
    return null;
  }
}

function readLocalStorageValue(key) {
  try {
    if (typeof window === 'undefined') return '';
    return window.localStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

const windowCfg = readWindowConfig();

const supabaseUrl =
  (process.env.REACT_APP_SUPABASE_URL || '').trim() ||
  (windowCfg?.url || '').trim() ||
  readLocalStorageValue('SUPABASE_URL').trim();
const supabaseAnonKey =
  (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim() ||
  (windowCfg?.anonKey || '').trim() ||
  readLocalStorageValue('SUPABASE_ANON_KEY').trim();

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey);
export const SUPABASE_URL = supabaseUrl;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in a .env.local file.'
  );
}

export const supabase = isSupabaseConfigured ? createClient(supabaseUrl, supabaseAnonKey) : null;

// Optional configuration (lets you swap bucket/table per project without code changes)
export const STORAGE_BUCKET =
  (process.env.REACT_APP_SUPABASE_STORAGE_BUCKET || '').trim() ||
  (windowCfg?.storageBucket || '').trim() ||
  readLocalStorageValue('SUPABASE_STORAGE_BUCKET').trim() ||
  'event-images';

export const EVENTS_TABLE =
  (process.env.REACT_APP_SUPABASE_EVENTS_TABLE || '').trim() ||
  (windowCfg?.eventsTable || '').trim() ||
  readLocalStorageValue('SUPABASE_EVENTS_TABLE').trim() ||
  'events';
